import type { ReactNode } from 'react';

interface InviteFormFieldProps {
  label: string;
  required?: boolean;
  accent?: string;
  hint?: string;
  children: ReactNode;
}

/** Small label + accent + hint wrapper used by inputs in the Invite drawer. */
export default function InviteFormField({
  label,
  required,
  accent,
  hint,
  children,
}: InviteFormFieldProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <label className="text-[12px] font-semibold text-bark-800 dark:text-[#e8ece9]">
          {label} {required && <span className="text-clay-600">*</span>}
        </label>
        {accent && (
          <span className="text-[10.5px] text-stone-500 dark:text-stone-400">{accent}</span>
        )}
      </div>
      {children}
      {hint && (
        <div className="text-[11px] text-stone-500 dark:text-stone-400 mt-1.5 leading-snug">
          {hint}
        </div>
      )}
    </div>
  );
}
